document.addEventListener('DOMContentLoaded', function() {
  // Reveal animation
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.1 });
  reveals.forEach(el => observer.observe(el));

  // Konvertera versaler till Title Case
  function toTitleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
  }

  const selectors = [
    '.product-card__name',
    '.product-page__title',
    '.collection-page__title',
    '.cart-item__name'
  ];

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.textContent = toTitleCase(el.textContent);
    });
  });
});